export function getDefaultSelectedOptions(linkedOperations) {
   const options = {
      applications: {},
      modules: {},
      functionalities: {},
      operations: {}
   }
   linkedOperations.forEach(item => {
      const { operation } = item
      options.operations[operation.id] = true
      const { functionality } = operation
      options.functionalities[functionality.id] = true
      const { module } = functionality
      options.modules[module.id] = true
      const { application } = module
      options.applications[application.id] = true
   })
   return options
}

export function convertArrayToMap(arrayList) {
   const map = {}
   arrayList.forEach(item => {
      map[item.id] = {
         name: item.name,
         checked: false
      }
   })
   return map
}

export function setDefaultSelectedOptions(map, defaultSelectedOptionsMap) {
   const mapWithSelection = {}
   Object.keys(map).forEach(mapPropertyKey => {
      mapWithSelection[mapPropertyKey] = {
         ...map[mapPropertyKey],
         checked: !!defaultSelectedOptionsMap[mapPropertyKey]
      }
   })
   return mapWithSelection
}

export function getSelectedOptionsWithParent(optionsLists) {
   let selectedOptions = []
   for (const parentOptionId in optionsLists) {
      const optionsList = optionsLists[parentOptionId]
      if (optionsList.visible) {
         const itemsMap = optionsList.itemsMap
         selectedOptions = selectedOptions.concat(getSelectedOptions(itemsMap))
      }
   }
   return selectedOptions
}

export function getSelectedOptions(itemsMap) {
   const selectedOptions = []
   for (const optionId in itemsMap) {
      const item = itemsMap[optionId]
      if (item.checked) {
         selectedOptions.push({
            id: optionId,
            name: item.name
         })
      }
   }
   return selectedOptions
}

export function deselectItems(itemsMap) {
   const deselectedOptionsMap = {}
   for (const optionId in itemsMap) {
      deselectedOptionsMap[optionId] = {
         ...itemsMap[optionId],
         checked: false
      }
   }
   return deselectedOptionsMap
}

export function getItemName(itemsList, itemId) {
   const { name } = itemsList.find(item => item.id === itemId)
   return name
}
